<template>
  <BaseSnack :type="type">
    {{ message }}
  </BaseSnack>
</template>

<script lang="ts" setup>
import BaseSnack from "@/components/BaseSnack.vue";
import type { SnackType } from "@/components/snackType";

withDefaults(
  defineProps<{
    type?: SnackType;
    message: string;
  }>(),
  {
    type: "neutral",
  },
);
</script>

<style module lang="scss"></style>
